import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";

export const Gallery = () => {
  return (
    <section id="aventuras" data-testid="gallery-section" className="py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
        <p className="text-[11px] text-[#FF5508] mb-4">
            Galería de aventuras
          </p>
          <h2 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418]">
            Rutas que ya
            <br />
            <span className="text-outline">se escribieron</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[240px] gap-5">
          {GALLERY.map((photo, i) => (
            <motion.figure
              key={photo.src}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden border border-white/10 ${
                photo.span === "wide" ? "sm:col-span-2" : ""
              } ${photo.span === "tall" ? "row-span-2" : ""}`}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />

            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
